import React, { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import 'leaflet-control-geocoder';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';

const GeocodingControl = ({ options }) => {
    const map = useMap();
    const geocoderRef = useRef(null);
    
    useEffect(() => {
        // Only initialize if we have a map and don't already have a geocoder
        if (!map || geocoderRef.current) return;
        
        try {
            const geocoder = L.Control.geocoder({
                defaultMarkGeocode: false,
                position: 'topleft',
                ...options
            });
            
            geocoder.on('markgeocode', function (e) {
                try {
                    var bbox = e.geocode.bbox;
                    var poly = L.polygon([
                        bbox.getSouthEast(),
                        bbox.getNorthEast(),
                        bbox.getNorthWest(),
                        bbox.getSouthWest()
                    ]);
                    map.fitBounds(poly.getBounds());
                } catch (error) {
                    console.error("Error in markgeocode handler:", error);
                }
            });
            
            geocoder.addTo(map);
            geocoderRef.current = geocoder;
        } catch (error) {
            console.error("Error initializing geocoder:", error);
        }

        // Cleanup function - safely remove the control
        return () => {
            try {
                if (map && geocoderRef.current) {
                    map.removeControl(geocoderRef.current);
                }
            } catch (error) {
                console.error("Error cleaning up geocoder control:", error);
            } finally {
                geocoderRef.current = null;
            }
        };
    }, [map, options]);

    return null;
};

export default GeocodingControl;